export default __webpack_public_path__ + "static/g3-light-logo-icon-b773453c9d8af38516976a722f1f130e.svg";